import UserCommentCard from './UserCommentCard';

export default UserCommentCard;
